const ws = typeof WebSocket !== 'undefined' ? WebSocket : null
export { ws as WebSocket }
